import NewsfeedEmptyStates from './NewsfeedEmptyPageStates';

export default {
  ReactComponent: NewsfeedEmptyStates,
  bindings: {
    isAdmin: '<',
    emptyStateType: '<',
    currentPage: '<',
  },
};
